import { render } from "./RegisterPointExchangeMagnification.vue?vue&type=template&id=7d108d5c&scoped=true&ts=true"
import script from "./RegisterPointExchangeMagnification.vue?vue&type=script&lang=ts"
export * from "./RegisterPointExchangeMagnification.vue?vue&type=script&lang=ts"

import "./RegisterPointExchangeMagnification.vue?vue&type=style&index=0&id=7d108d5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d108d5c"]])

export default __exports__